
<ng-container *ngIf="userData" >
  <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="mb-2 border rounded">
          <app-not-verified *ngIf="userData.code === this.errorCodes.RESTRICTED_CONTENT_ERROR_CODE" [callingfrom]="callingfrom" [dataObj]="userData.data.pre_document_card"></app-not-verified>
          <div class="text-center" *ngIf="userData.code === this.errorCodes.ERROR_1025">
            <h5 class="mb-3 fnt-weight500">{{userData.data.pending_document?.message_title}}</h5>
            <p>{{userData.data.pending_document?.message_description}}</p>
          </div>

          <div class="text-center" *ngIf="userData.code === this.errorCodes.ERROR_1005">
            <p>{{userData.msg}}</p>
          </div>
        </div>
      </div>
  </div>
</ng-container>

<ng-container *ngIf="!isFinished; else loadData">
   <ng-container *ngTemplateOutlet="loader"></ng-container>
</ng-container>

<ng-template #loadData>
    <div class="game-play-container" *ngIf="(!userData && gameResourceUrl); else emptyUrl">
        <iframe width="100%" #gameContent
          height="100%"
          frameBorder="0"
          [src]="gameResourceUrl | safeurl">
        </iframe>
    </div>
</ng-template>

<ng-template #emptyUrl>
  <div class="text-center">
    {{mls.languageText.middle_ware.key4}}
  </div>
</ng-template>

<ng-template #loader>
    <div class="text-center">
        <img class="text-center" src="assets/images/loader-small.svg" width="40" height="100" alt="loader">
    </div>
</ng-template>

